export const PHONE_REQUIREMENTS_MESSAGE =
  "Enter a valid phone number (7-15 digits, numbers only).";

export function normalizePhone(phone) {
  return phone.replace(/[\s-]/g, "");
}

export function isValidPhone(phone) {
  const cleaned = normalizePhone(phone.trim());
  return /^\+?[0-9]{7,15}$/.test(cleaned);
}
